import * as firebase from "firebase/app";
import "firebase/analytics";

import { firebaseConfig } from "../config"

export const config = firebase.initializeApp(firebaseConfig);
export const analytics = config.analytics();
